import type {DocumentNode} from "graphql";
import {AuthStorage} from "../logic/storage";

export type SupportedOperation = "query" | "mutation";

export function getOperationKind(document: DocumentNode): SupportedOperation {
  const operationDefinition = document?.definitions?.find((definition) => {
    return definition.kind === "OperationDefinition";
  });

  if (operationDefinition?.kind === "OperationDefinition" && operationDefinition.operation === "mutation") {
    return "mutation";
  }

  return "query";
}

export function getAuthorizationHeaders(): Record<string, string> | undefined {
  const token = AuthStorage.get("token");

  if (!token) {
    return undefined;
  }

  return {
    authorization: `Bearer ${token}`,
  };
}
